import request from '@/utils/request'
import URL from './urlTranslator'

// 查询全部美国商品编码
export function queryAllUSCommodityCode() {
  return request({
    url: URL.mdm.usCommodityCode.queryAll,
    method: 'get'
  })
}

// 查询美国商品编码
export function queryUSCommodityCode(params) {
  return request({
    url: URL.mdm.usCommodityCode.query,
    method: 'get',
    params
  })
}

// 保存美国商品编码
export function saveUSCommodityCode(data) {
  return request({
    url: URL.mdm.usCommodityCode.save,
    method: 'post',
    data
  })
}

// 删除美国商品编码
export function deleteUSCommodityCode(uuid) {
  return request({
    url: URL.mdm.usCommodityCode.delete,
    method: 'delete',
    params: { uuid }
  })
}
